import React from 'react';
import { Button } from 'reactstrap';
import styled from 'styled-components';
const SubmitButton = styled.button`
  background-color: #0071e1;
  color: white;
  border: 1px solid #0071e1;

  &:hover {
    background-color: #005cbf;
    border-color: #005cbf;
  }
`;
class ButtonKeyEnter extends React.Component {
  constructor(props) {
    super(props);
  
    this.innerRef = React.createRef();
  }


  focus(){
    this.innerRef.current.focus()
  }

handleKeyPress(target) {
  if(target.charCode==13){
    alert('Enter clicked!!!');    
  } 
}

render() {
  return (
    <SubmitButton {...this.props} innerRef={this.innerRef}   />
  );
 }
}

export default ButtonKeyEnter